import direct from 'ml-direct';
export function directOptimization(data, sumOfShapes, options) {
    const { minValues, maxValues, maxIterations, epsilon, tolerance, tolerance2, initialState, } = options;
    const objectiveFunction = getObjectiveFunction(data, sumOfShapes);
    const result = direct(objectiveFunction, 
    // direct internally converts ArrayLike to Float64Array,
    // so we can safely cast minValues and maxValues to number[]
    minValues, maxValues, {
        iterations: maxIterations,
        epsilon,
        tolerance,
        tolerance2,
        initialState,
    });
    const { optima } = result;
    return {
        parameterError: result.minFunctionValue,
        iterations: result.iterations,
        parameterValues: optima[0],
    };
}
function getObjectiveFunction(data, sumOfShapes) {
    const { x, y } = data;
    const nbPoints = x.length;
    return (parameters) => {
        const fct = sumOfShapes(parameters);
        let error = 0;
        for (let i = 0; i < nbPoints; i++) {
            error += (y[i] - fct(x[i])) ** 2;
        }
        return error;
    };
}
//# sourceMappingURL=directOptimization.js.map